import styled from "styled-components";

export const Form = styled.form`
  margin-top: -60px;

  font-family: "Fredoka One", cursive;
  & input {
    height: 7vh;
    width: 20vw;
  }
  & button {
    height: 8.5vh;
    cursor: pointer;
  }
`;
